import React, { Component } from "react";
import "react-table/react-table.css";
import { fetchMethod } from "../../../FetchMethod";
import "../../tables/reactTable.css";
import Delete from "../../assets/delete1.png";
import { TextField, MenuItem, Button } from "@material-ui/core";
import { Checkbox } from "pretty-checkbox-react";
import ReactTableComponent from "../../tables/ReactTable";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import ConvertToTemp from "./ConvertToTemp";
import { Link } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NextArrow from "../../assets/upAerrow.png";

import { URLDATA2 } from "../../../config";
import {
  getCampaignType,
  CampaignTempListsInfo,
  listCampaignTempList,
  CampaignTempListsSelectAll,
  fetchTempListDetail,
  GetAllCampaign,
  //CampaignMoveAllContactToTemp,
  ExcelDataQuery
} from "../../../Queries";

import Photo from "../../assets/photo.png";
import SearchIcon from "../../assets/search.png";
import "../CampaignTables.css";
import "../CampaignTabs.css";
import swal from "sweetalert";
import "./CampaignTempList.css";
import "./styles.scss";
import {
  MoveToContact,
  RemoveToContact,
  MoveAllContactToTemp
} from "../../../config";

import { Drawer } from "@material-ui/core";
import CampaignTempListDetails from "./CampaignTempListDetails";
var moment = require("moment");
class CampaignTempListTab extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = this.state = {
      
      search: "",
      loading: false,
      campaignTempList: [],
      campaignTempListIds: [],
      campaignTempAllSelectedList: [],
      selected: {},
      selectAll: 0,
      limit: 0,
      offset: 0,
      selectedArray: [],
      tempListTotalCount: 0,
      clickToSearch: false,
      tempLists: [],
      selectCamp: "Select a campaign",
      tempListId: "",
      searchFlag: false,
      selectedListValue: "All",
      selectedListName: "All",
      status: "",
      show: false,
      totalDataLength: "",
      disabled: false,
      getData: [],
      openDetails: false,
      getCampaignId: null,
      NewCampaignid: null,
      getCustomer: [],
      contactStatus: null,
      campaignStatus: null,
      ContactDetailsWorkflow: [],
      ContactDetailsMessages: [],
      Row: "",
      columnFilter: "",
      shortfilter: false,
      selectedCampaignValue: "",
      CampaignList: [],
      campaignContactsExportData: [],
      campaignNatureType:1,
      tempRow: null,
    };
  }

  componentDidMount() {     
    this.campaignType();   
    this.fetchTempList();
    this.getAllData();
    this.fetchCampaignList();
    this.setState({ NewCampaignid: this.props.campaignId });
  }

  ExportData = () => {
    const filter = this.filter();

    fetchMethod(fetchTempListDetail, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          campaignContactsExportData:
            res.data.allTempcontactsdetails.Tempcontactsdetails
        });
      });
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.id });
  };
  fetchCampaignList = () => {
  
    let filter = {};
    if (
      this.props.type === "Follow on Campaign" ||
      this.props.type === "Nurture Campaign" ||
      this.props.type === "1st connection campaign"||
      this.props.type === "In mail campaign"
    ) {
      if (this.props.datafromcampaign) {
        filter = {
          where: {
            linkedinid: this.props.linkedinid,
            id: this.props.datafromcampaign
          }
        };
      } else {
        filter = {
          where: {
            linkedinid: this.props.linkedinid,
            active: 1,
            order: "name asc"
          }
        };
      }
    } else {
      filter = {
        where: {
          id: 0,
          linkedinid: this.props.linkedinid,
          active: 1,
          order: "name asc"
        }
      };
    }

    fetchMethod(GetAllCampaign, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        responseAsJson !== undefined
          ? this.setState({
              loading: false,
              show: false,
              CampaignList: responseAsJson.data.allCampaigns.Campaigns
            })
          : this.setState({ loading: true });
      })
      .catch(() => {
        this.setState({ loading: true });
      });
  };

  campaignType = () => {
     
    const filterId = {
      where: {
        id: this.props.campaignId,
    
      }
    };
    fetchMethod(getCampaignType, filterId)
      .then(response => {
        
        return response.json();
      })
      .then(responseAsJson => {
           
        this.setState(

              {
                campaignNatureType: responseAsJson.data.allCampaigns.Campaigns[0].salesNavigator
              },
           
            )
          
      })
      .catch(() => {
        this.setState({ loading: true });
      });
  };

  fetchTempList = () => {
    const filter = {
      where: {
        campaignid: this.props.campaignId,
        active: 1,
        order: "name asc"
      }
    };
    fetchMethod(listCampaignTempList, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        responseAsJson !== undefined
          ? this.setState(
              {
                loading: false,
                show: false,
                tempLists: responseAsJson.data.allTemplists.Templists
              },
              () => {
                let sortedList = [...this.state.tempLists];

                this.setState({ tempLists: sortedList });
                this.props.detailEdit(this.state.show);
              }
            )
          : this.setState({ loading: true });
      })
      .catch(() => {
        this.setState({ loading: true });
      });
  };

  getAllData = () => {
    const filter = this.filter();
    fetchMethod(CampaignTempListsSelectAll, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        responseAsJson !== undefined
          ? this.setState({
              totalDataLength:
                responseAsJson.data.allTempcontactsdetails !== undefined
                  ? responseAsJson.data.allTempcontactsdetails
                      .Tempcontactsdetails.length
                  : ""
            })
          : this.setState({ loading: true });
      })
      .catch(() => {
        this.setState({ loading: true });
      });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  campaignTempListResponse = response => {
    this.setState({
      campaignTempList:
        response.data.allTempcontactsdetails.Tempcontactsdetails,
      tempListTotalCount: response.data.allTempcontactsdetails.totalCount
    });
  };

  handleList = event => {
    this.setState(
      {
        selectedListValue: event.target.outerText,
        moveToContactCount: 0
      },
      () => {
        const templists = [...this.state.tempLists];
        templists.map(list => {
          if (this.state.selectedListValue === "All") {
            this.setState({ tempListId: "", clickToSearch: true }, () => {
              this.onSearchClick();
            });
          } else if (this.state.selectedListValue === list.name) {
            this.setState(
              {
                tempListId: list.id,
                selectedListName: list.name,
                clickToSearch: true
              },
              () => {
                this.onSearchClick();
              }
            );
          }
          return null;
        });
      }
    );
  };
  ExportCampaignListData = async () => {
    swal("Successfully Imported", { icon: "success" }).then(value => {
      this.fetchTempList();
      this.child.current.searchFetch(this.state.limit, this.state.offset);
    });

    await fetch(
      `${MoveAllContactToTemp.url}` +
        `${this.state.selectedCampaignValue}` +
        `&newCampaignId=${this.props.campaignId}` +
        `&access_token=${MoveAllContactToTemp.token}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    )
      .then(res => res.json())
      .then(res => {
        if (res.status === 401) {
          localStorage.clear();
          window.location = "/";
        } else {
        }
      });
  };
  HeaderinExcel = () => {
    let fileData = [];
    fileData.push({
      FirstName: "",
      LastName: "",
      JobTitle: "",
      EmailAddress: "",
      LinkedInProfile: "",
      Country: "",
      Company: "",
      Industry: ""
    });
    return fileData;
  };
  handleCampaignExportList = event => {
    this.setState(
      {
        selectedCampaignValue: event.target.value
      },
      () => {
        this.ExportCampaignListData();
      }
    );
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        selectedListName: "All",
        selectCamp: "Select a campaign",
        tempListId: "",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      }
    );
  };
  exportToExcel = () => {
    let filedata = this.HeaderinExcel();

    let fileName =
      moment().format("YYYYMMDDhmmss") + +Math.floor(Math.random() * 100);

    try {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".csv";
      const ws = XLSX.utils.json_to_sheet(filedata);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "csv",
        type: "array"
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      swal("Error", { icon: "error" });
    }
  };
  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    }
  };
  onDrop = acceptedFile => {
    this.setState({ selectExcel: acceptedFile[0] }, () => console.log("e"));
  };

  uploadExcel = () => {
    let formData = new FormData();

    let name = this.state.selectExcel.name;
    var newFile = new File([this.state.selectExcel], name, {
      type: this.state.selectExcel.type
    });

    formData.append("file", newFile);
    let xhr = new XMLHttpRequest();

    xhr.open("POST", URLDATA2.uploadUrl);

    xhr.send(formData);

    // let fileName = "";

    // xhr.onreadystatechange = function() {
    //   if (xhr.readyState === XMLHttpRequest.DONE) {
    //     fileName = JSON.parse(xhr.responseText).name;
    //   }
    // };

    fetchMethod(
      ExcelDataQuery(
        this.state.selectExcel.name + "&&" + this.state.NewCampaignid
      )
    )
      .then(res => res.json())
      .then(res => {
        // var bb = res.Body;
        const filter = this.filter();
        fetchMethod(fetchTempListDetail, filter)
          .then(res => res.json())
          .then(res => {
            this.setState({
              campaignContactsExportData:
                res.data.allTempcontactsdetails.Tempcontactsdetails
            });
          });

        this.setState({ selectExcel: undefined });
        if (res.data.TempcontactsdetailsUploadUserExcel != null) {
          swal(res.data.TempcontactsdetailsUploadUserExcel, {
            icon: "success"
          }).then(value => {
            this.fetchTempList();
            this.child.current.searchFetch(this.state.limit, this.state.offset);
          });
        } else {
          swal(res.errors[0].message, {
            icon: "warning"
          }).then(value => {
            this.fetchTempList();
            this.child.current.searchFetch(this.state.limit, this.state.offset);
          });
        }
      })
      .catch(e => {
        if (e.message) {
          swal({
            title: "FAILED",
      
            icon: "warning"
          });
        }
      });
  };
  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleSearchChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
      },
      200
    );
  };
///////////////////////////////////////////////////////////////
  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(CampaignTempListsSelectAll, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allTempcontactsdetails.Tempcontactsdetails.map(
          i => {
            return allselectedIds.push({ id: i.id });
          }
        );
        this.setState(
          {
            campaignTempAllSelectedList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignTempAllSelectedList.map(item => {
              consolidateArray[item.id] = true;
              return selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(() => {
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
  
    if (sarray.length === this.state.tempListTotalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  convertArrayToObject = selectedArrayIds => {
    let SelectedIds = [];
    selectedArrayIds.map(item => {
      return SelectedIds.push({ id: item, createdBy: MoveToContact.createdBy });
    });
    return SelectedIds;
  };

  OnMoveToContactClick = async selectedArray => {
   
    this.setState({ disabled: true });
    let selectedArrayIds = [];
    selectedArray.map(a => {
      return selectedArrayIds.push(a.id);
    });
    let SelectedIds = this.convertArrayToObject(selectedArrayIds);
    if (selectedArray.length > 0) {
      SelectedIds = JSON.stringify(SelectedIds);
      await fetch(
        `${MoveToContact.url}` +
          `${SelectedIds}` +
          `&access_token=${MoveToContact.token}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => res.json())
        .then(res => {
          if (res.status === 401) {
            localStorage.clear();
            window.location = "/";
          } else {
            this.setState(
              { selectedArray: [], selectAll: false, selected: {} },
              () => {
                this.fetchTempList();
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
                swal("Successfully moved", { icon: "success" });
                this.setState({ disabled: false });
              }
            );
          }
        })
        .catch(e => {
          swal({ title: "Please try again after some time", icon: "warning" });
          this.setState({ disabled: false });
        });
    } else {
      swal("Please select contact", { icon: "warning" });
      this.setState({ disabled: false });
    }
  };
  OnRemoveToContactClick = async selectedArray => {
    this.setState({ disabled: true });
    let selectedArrayIds = [];
    selectedArray.map(a => {
      return selectedArrayIds.push(a.id);
    });
    let SelectedIds = this.convertArrayToObject(selectedArrayIds);
    if (selectedArray.length > 0) {
      SelectedIds = JSON.stringify(SelectedIds);
      await fetch(
        `${RemoveToContact.url}` +
          `${SelectedIds}` +
          `&access_token=${RemoveToContact.token}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => res.json())
        .then(res => {
          if (res.status === 401) {
            localStorage.clear();
            window.location = "/";
          } else {
            this.setState(
              { selectedArray: [], selectAll: false, selected: {} },
              () => {
                this.fetchTempList();
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
                swal("Successfully Removed", { icon: "success" });
                this.setState({ disabled: false });
              }
            );
          }
        })
        .catch(e => {
          swal({ title: "Please try again after some time", icon: "warning" });
          this.setState({ disabled: false });
        });
    } else {
      swal("Please select contact", { icon: "warning" });
      this.setState({ disabled: false });
    }
  };

  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };
  fetchContactDrawerDetails = (side, open, row) => event => {
  
    const test = {
      where: { id: row.id }
    };

    fetchMethod(fetchTempListDetail, test)
      .then(res => res.json())
      .then(res => {
        res.data.allTempcontactsdetails !== undefined
          ? this.setState({
              getData:
                res.data.allTempcontactsdetails !== undefined &&
                res.data.allTempcontactsdetails !== null
                  ? res.data.allTempcontactsdetails.Tempcontactsdetails[0]
                  : "",
              ContactDetailsMessages:
                res.data.allTempcontactsdetails !== undefined &&
                res.data.allTempcontactsdetails !== null
                  ? res.data.allTempcontactsdetails.Tempcontactsdetails[0]
                      .ContactDetailsMessages.Tempcontactmessages
                  : ""
            })
          : this.setState({ loading: true });
      });
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };


  closeDetails = () => {
 
    this.setState({ openDetails: false, getData: []});
  };

  fetchRefresh = response => {
    this.fetchName(response);
  };
  fetchName = response => {
  
    const test = {
      where: { id: response }
    };

    fetchMethod(fetchTempListDetail, test)
      .then(res => res.json())
      .then(res => {
        res.data.allTempcontactsdetails !== undefined
          ? this.setState({
              getData:
                res.data.allTempcontactsdetails !== undefined &&
                res.data.allTempcontactsdetails !== null
                  ? res.data.allTempcontactsdetails.Tempcontactsdetails[0]
                  : ""
            })
          : this.setState({ loading: true });
      });
  };

  filter = () => {
    const search = this.state.clickToSearch
      ? this.state.search.trim().replace(/\s\s+/g, " ")
      : "";

    const like = `%${search}%`;
    const filt =
      this.state.tempListId !== ""
        ? {
            where: {
              campaignid: this.props.campaignId,
              templistid: this.state.tempListId,
              active: "1 ",
              order: this.state.columnFilter,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            },
        first: this.state.offset,
            last:this.state.limit,
          }
        : {
            where: {
              campaignid: this.props.campaignId,
              active: "1 ",
              order: this.state.columnFilter,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            },
               first: this.state.offset,
            last:this.state.limit,
          };

    return filt;
  };
  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ columnFilter: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },

      clientY: e.clientY,
      clientX: e.clientX
    });
    this.ExportData();
  };

  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  render() {
  
    let filt = this.filter();

    const { selectedEngagedRow } = this.state;
    // const campaignContactsExportData = [
    //   ...this.state.campaignContactsExportData
    // ];

    var totalContactAll = this.state.tempListTotalCount;
    let moveToContactCount = this.state.selectedArray.length;
    const newCampaignTempList = [...this.state.campaignTempList];
    newCampaignTempList.map(profile => {
      let image =
        profile.profileimage !== undefined && profile.profileimage !== null
          ? profile.profileimage.substr(0, 5)
          : "";
      if (image === "https") {
        profile.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              profile
            )}
          >
            <img
              src={profile.profileimage}
              style={{ borderRadius: "50%", width: "30px", cursor: "pointer" }}
           
              onClick={this.fetchContactDrawerDetails(
                "openDetails",
                true,
                profile
              )}
            />
          </div>
        );
      } else {
        profile.Image = (
          <img
            src={Photo}
            style={{ borderRadius: "50%", width: "30px", cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              profile
            )}
          />
        );
      }
   
      return null;
    });

    const CampaignTempLists = [
      {
        Header: obj => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style={{ "text-decoration": "thick" }}
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selectAll}
              onChange={e => {
                this.toggleSelectAllRow(e.target.checked);
              }}
            />
          );
        },
        width: 38,
        Cell: rowInfo => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style={{ "text-decoration": "thick" }}
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selected[rowInfo.original.id] === true}
              onChange={() =>
                this.toggleRowNew(rowInfo.original.id, rowInfo.original)
              }
            />
          );
        }
      },
      {
        Header: "Image",
        accessor: "Image",
        width: 55,
        
      },
      // {
      //   Header: "Gender",
      //   accessor: "gender",
            
      // },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "name",
         width: 170,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },
      {
        Header: "First Name",
        accessor: "fname"
      },
      {
        Header: "Surname",
        accessor: "surname"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Company
            </div>
          );
        },
        accessor: "organization",
        width: 200,
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Position
            </div>
          );
        },
        accessor: "designation",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location",
        width: 200,
      },
      {
        Header: "Headline",
        accessor: "headline",
        width: 200,
      },
   
      {
        Header: "Action",
        Cell: row => (
          <div className="iconButton">
            {localStorage.getItem("role") !== "CUSTOMER" ? (
              <a aria-haspopup="true" onClick={this.showEngagedToPopup(row)}>
                <img
                  src={Delete}
                  alt="Delete"
                  className="deleteButton"
               
                />
              </a>
            ) : (
              ""
            )}
            
          </div>
        )
      }
    ];

    return (
      
      <div className="CampaignTempList">
        <div className="CampaignTempListHeader">
          <div className="CampaignTempListFilters">
            <Drawer
              anchor="right"
              open={this.state.openDetails}
              onClose={() => this.closeDetails()}
            >
              <CampaignTempListDetails
                refreshMessage={this.fetchRefresh}
                onSearchClick={this.onSearchClick}
                Close={() => this.closeDetails()}
                details={this.state.getData}
                tableRerender={this.child.current}
                limit={this.state.limit}
                offset={this.state.offset}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                heading={"Contact  Details"}
              />
            </Drawer>

            <div className="selectListDiv">
              <Autocomplete
                id="outlined-select-currency"
              
                placeholder="Select"
                margin="normal"
                variant="outlined"
                onChange={this.handleList}
                value={this.state.selectedListName}
                blurOnSelect={true}
                options={this.state.tempLists ? this.state.tempLists : []}
                renderOption={option => (
                  <MenuItem value={option.id}>{option.name}</MenuItem>
                )}
                renderInput={params => (
                  <TextField
                    id="outlined-select-currency"
                    label="List"
                    {...params}
                    variant="outlined"
                    value={null}
                    InputProps={{
                      ...params.InputProps,

                      endAdornment: (
                        <img
                          src={NextArrow}
                          style={{
                            width: "17px",
                              cursor: "pointer"
                          }}
                        />
                      )
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      ...params.inputProps
                    }}
                  />
                )}
              />
            </div>
         

            <div className="searchDiv">
              <TextField
                id="outlined-search"
                label="Search"
                placeholder="Search name here..."
                type="text"
                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleSearchChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>

            <div className="CampaignContactsButton">
              <Button
                className="button"
                onClick={this.clearFilters}
                style={{ textTransform: "capitalize" }}
              >
                Reset All
              </Button>
            </div>

            {this.state.campaignNatureType === 0 && (
      
              <div className="Samplebutton">
                <Link style={{ color: "#1a0dab" }} onClick={this.exportToExcel}>
                  Sample File
                </Link>
               
                {this.state.selectExcel ? (
                  <Button
                    variant="outlined"
                    visible="true"
                    color="primary"
                    className="btnDvrStatusReport"
                    component="span"
                    onClick={this.uploadExcel}
                  >
                    Upload Excel
                  </Button>
                ) : (
                  <form>
                    <input
                      style={{ display: "none" }}
                      accept=".csv"
                      //accept=".xlsx"
                      id="contained-button-file"
                      type="file"
                      onChange={e => this.onDrop(e.target.files)}
                    />
                    <label htmlFor="contained-button-file">
                      <Button
                        variant="outlined"
                        color="primary"
                        visible="true"
                        className="btnDvrStatusReport"
                        component="span"
                      >
                        Upload Excel Sheet
                      </Button>
                    </label>
                  </form>
                )}

                {this.state.selectExcel ? (
                  <ul className="excelupload">
                    <li>{this.state.selectExcel.name}</li>
               
                  </ul>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>

          {(this.props.type === "Nurture Campaign" ||
            this.props.type === "Follow on Campaign" ||
            this.props.type === "1st connection campaign" ||
            this.props.type === "In mail campaign") && (
            <div className="selectListDiv">
              <Autocomplete
                id="country-demo"
                value={this.state.selectCamp}
                blurOnSelect={true}
                onChange={this.handleCampaignExportList}
                options={this.state.CampaignList ? this.state.CampaignList : []}
                renderOption={option => (
                  <MenuItem value={option.id}>{option.name}</MenuItem>
                )}
                renderInput={params => (
                  <TextField
                    id="outlined-select-currency"
                    label="Import From"
                    {...params}
                    variant="outlined"
                    value={this.state.selectCamp}
                    InputProps={{
                      ...params.InputProps,

                      endAdornment: (
                        <img
                          src={NextArrow}
                          style={{
                            width: "17px"
                          }}
                        />
                      )
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      ...params.inputProps
                    
                    }}
                  />
                )}
              />
            </div>
          )}
       
          {selectedEngagedRow && (
            <ConvertToTemp
              refresh={() => this.ExportData()}
              target={selectedEngagedRow && selectedEngagedRow.anchorEl}
              contactStatus={selectedEngagedRow.original.contactstatus}
              campaignStatus={selectedEngagedRow.original.campaignstatus}
              id={selectedEngagedRow.original.id}
              clientY={this.state.clientY}
              clientX={this.state.clientX}
              tableRerender={this.child.current}
              onClose={this.onCloseEngagedPopup}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          )}
        
        </div>

        <div className="CampaignTempListRightFilters">
          <span>
            {moveToContactCount === 0 || moveToContactCount === undefined
              ? "No out of " + `${totalContactAll}` + " contacts are selected"
              : moveToContactCount === 1
              ? `${moveToContactCount}` +
                " out of " +
                `${totalContactAll}` +
                " contacts are selected"
              : `${moveToContactCount}` +
                " out of " +
                `${totalContactAll}` +
                " contacts are selected"}
          </span>

          <Button
            onClick={() => this.OnMoveToContactClick(this.state.selectedArray)}
            disabled={this.state.disabled}
          >
            <span style={{ color: "#3F6BE0", fontSize: "13px" }}>
              Move selected to contacts
            </span>
          </Button>

          <Button
            onClick={() =>
              this.OnRemoveToContactClick(this.state.selectedArray)
            }
            disabled={this.state.disabled}
          >
            <span style={{ color: "#FF2C00", fontSize: "13px" }}>
              Remove selected
            </span>
          </Button>
          {/* </div> */}
        </div>
        <ReactTableComponent
          ref={this.child}
          listData={newCampaignTempList}
          listConfig={CampaignTempLists}
          setData={this.campaignTempListResponse}
          query={CampaignTempListsInfo}
          totalCount={this.state.tempListTotalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filt}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}

export default CampaignTempListTab;
